import request from '@/utils/request'
const apiPath = '/live/liveBlessingBag'
import { downloadBlob } from '@/utils/download'
const liveBlessingBagApi = {
  /**
   * 新增【直播福袋】
   */
  create(data) {
    return request.post(apiPath + '/tee', data)
  },
  /**
   * 修改【直播福袋】
   */
  update(data) {
    return request.put(apiPath + '/tee', data)
  },
  /**
   * 分页查询【直播福袋】
   */
  fetchList(query) {
    return request.get(apiPath + '/tee', { params: query })
  },
  /**
   * 查看【直播福袋】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/tee/${id}`)
  },
  /**
   * 删除单个【直播福袋】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  exportExcel(query) {
    return request.get(`${apiPath}/export`, { responseType: 'blob', params: query })
      .then(res => downloadBlob(res, '福袋列表.xlsx'))
  },
  /**
   * 取消福袋
   */
  cancel(data) {
    return request.post(`${apiPath}/tee/cancel`, data)
  },
  /**
   * 开奖·强制型
   */
  lotteryDraw(data) {
    return request.post(`${apiPath}/tee/lotteryDraw`, data)
  },
}
export default liveBlessingBagApi
